import Nullstack from 'nullstack';
export default function IconArrowAutofitUp({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-autofit-up",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"
  }), "   ", Nullstack.element("path", {
    d: "M18 20v-17"
  }), "   ", Nullstack.element("path", {
    d: "M15 6l3 -3l3 3"
  }), " ");
}